import React from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    // Generate page numbers to display
    // We want to show a spread of pages around the current page
    const maxVisiblePages = 7;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = startPage + maxVisiblePages - 1;

    if (endPage > totalPages) {
        endPage = totalPages;
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
    }

    // Size and style classes based on distance from current page
    const getBubbleStyle = (page) => {
        const distance = Math.abs(currentPage - page);

        switch (distance) {
            case 0:
                return 'w-12 h-12 text-lg bg-indigo-300 text-white font-black shadow-md shadow-indigo-200/50 z-10';
            case 1:
                return 'w-10 h-10 text-base bg-slate-100 text-slate-500 font-bold hover:bg-slate-200 cursor-pointer';
            case 2:
                return 'w-8 h-8 text-sm bg-slate-50 text-slate-400 font-semibold hover:bg-slate-100 cursor-pointer';
            case 3:
            default:
                return 'w-6 h-6 text-xs bg-slate-50/50 text-slate-300 font-medium hover:bg-slate-50 cursor-pointer';
        }
    };

    if (totalPages <= 1) return null;

    return (
        <div className="flex items-center justify-center gap-2 py-6">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`p-2 rounded-full transition-all ${currentPage === 1
                        ? 'text-slate-300 cursor-not-allowed'
                        : 'text-slate-600 hover:bg-slate-100 active:scale-95'
                    }`}
            >
                <ArrowLeft className="w-6 h-6" strokeWidth={2.5} />
            </button>

            <div className="flex items-center justify-center gap-2 px-4">
                {pages.map((page) => (
                    <button
                        key={page}
                        onClick={() => onPageChange(page)}
                        className={`rounded-full flex items-center justify-center transition-all duration-300 ${getBubbleStyle(page)}`}
                    >
                        {page}
                    </button>
                ))}
            </div>

            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`p-2 rounded-full transition-all ${currentPage === totalPages
                        ? 'text-slate-300 cursor-not-allowed'
                        : 'text-slate-600 hover:bg-slate-100 active:scale-95'
                    }`}
            >
                <ArrowRight className="w-6 h-6" strokeWidth={2.5} />
            </button>
        </div>
    );
};

export default Pagination;
